// extracted by mini-css-extract-plugin
export default {"card":"Banner_card__K08xC","arrow":"Banner_arrow__EZSxb"};